import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

/**
 * Shared label row for kl-* form controls (aligned with kalem-frontend-core kl-label).
 * Pass **i18n keys** for {@link label} / {@link labelDescription}; do not use `| translate` in parents.
 */
@Component({
  selector: 'kl-label',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './kl-label.html',
  styleUrl: './kl-label.scss',
})
export class KlLabelComponent {
  readonly label = input('');
  readonly labelDescription = input('');
  readonly isRequired = input(false);
  /** Associates label with control via <label for="…"> */
  readonly htmlFor = input('');
}
